import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  listItems: {
    '& li': {
      marginLeft: theme.spacing(-2.5),
    },
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    '& ul li::marker': {
      fontSize: '12px',
      lineHeight: '1',
    },
  },
  note: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
  },
  noteWrapper: {
    padding: theme.spacing(1.5, 1.5, 0, 1.5),
  },
}))
